import _regenerator from "/var/lib/jenkins/workspace/staging_gift_admin_deploy/node_modules/.pnpm/@babel+runtime@7.29.2/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _createForOfIteratorHelper from "/var/lib/jenkins/workspace/staging_gift_admin_deploy/node_modules/.pnpm/@babel+runtime@7.29.2/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper.js";
import _asyncToGenerator from "/var/lib/jenkins/workspace/staging_gift_admin_deploy/node_modules/.pnpm/@babel+runtime@7.29.2/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.reduce.js";
import "core-js/modules/es.object.to-string.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  props: {
    value: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    nextValue: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  data: function data() {
    return {
      imgHeight: 280 / 16,
      initialIndex: 0
    };
  },
  methods: {
    changeCarousel: function changeCarousel(curIndex) {
      this.initialIndex = curIndex;
    },
    getImgWH: function getImgWH(img_url) {
      return new Promise(function (resolve, reject) {
        var img = new Image();
        img.src = img_url;
        img.onload = function () {
          resolve({
            width: img.width,
            height: img.height
          });
        };
      });
    }
  },
  watch: {
    'value.config.value': {
      handler: function handler(values) {
        var _this = this;
        return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
          var imgInfoArr, _iterator, _step, item, _yield$_this$getImgWH, height, width, maxItem, _t;
          return _regenerator().w(function (_context) {
            while (1) switch (_context.p = _context.n) {
              case 0:
                if (!values.length) {
                  _context.n = 9;
                  break;
                }
                imgInfoArr = [];
                _iterator = _createForOfIteratorHelper(values);
                _context.p = 1;
                _iterator.s();
              case 2:
                if ((_step = _iterator.n()).done) {
                  _context.n = 5;
                  break;
                }
                item = _step.value;
                _context.n = 3;
                return _this.getImgWH(item.imageurl);
              case 3:
                _yield$_this$getImgWH = _context.v;
                height = _yield$_this$getImgWH.height;
                width = _yield$_this$getImgWH.width;
                imgInfoArr.push({
                  height: height,
                  width: width
                });
              case 4:
                _context.n = 2;
                break;
              case 5:
                _context.n = 7;
                break;
              case 6:
                _context.p = 6;
                _t = _context.v;
                _iterator.e(_t);
              case 7:
                _context.p = 7;
                _iterator.f();
                return _context.f(7);
              case 8:
                maxItem = imgInfoArr.reduce(function (prev, current) {
                  return prev['height'] > current['height'] ? prev : current;
                });
                _this.value.config.height = maxItem.height;
                _this.value.config.width = maxItem.width;
                _this.imgHeight = maxItem.height * 375 / maxItem.width / 16; // 将图片按宽高比例 除以16的基准值 获取对应的rem
              case 9:
                return _context.a(2);
            }
          }, _callee, null, [[1, 6, 7, 8]]);
        }))();
      },
      immediate: true,
      deep: true
    }
  },
  computed: {
    initialPadding: function initialPadding() {
      var _this$nextValue$confi;
      var margin_top = ((_this$nextValue$confi = this.nextValue.config) === null || _this$nextValue$confi === void 0 ? void 0 : _this$nextValue$confi.margin_top) || 0;
      if (margin_top < 0) {
        return Math.abs(margin_top / 16 / 2) + 'rem';
      }
      return '0rem';
    },
    Styles: function Styles() {
      var _this$value$config$pa = this.value.config.padding_lr,
        padding_lr = _this$value$config$pa === void 0 ? 0 : _this$value$config$pa;
      var baseSize = 32; //基准值 16*2 C端即可直接取值
      var paddingLR = padding_lr / baseSize;
      return {
        '--length': this.value.config.value.length,
        '--initialIndex': this.initialIndex + '',
        '--paddingLR': paddingLR + 'rem',
        paddingAll: paddingLR * 2
      };
    }
  }
};